import { render } from "./ItemIndexStampTile.vue?vue&type=template&id=63d4ddde&scoped=true"
import script from "./ItemIndexStampTile.vue?vue&type=script&lang=js"
export * from "./ItemIndexStampTile.vue?vue&type=script&lang=js"

import "./ItemIndexStampTile.vue?vue&type=style&index=0&id=63d4ddde&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-63d4ddde"

export default script